let openPopupLink = document.querySelector('.engraving-form__link a');
let popupSlider = document.querySelector('.engraving-slider__popup');
let popupOverlay = document.querySelector('.engraving-slider__overlay');
let closeButton = document.querySelector('.engraving-slider__close');

// OPEN POP-UP

if (openPopupLink != undefined) {
  openPopupLink.addEventListener('click', function (e) {
    e.preventDefault();
    popupSlider.classList.add('active');
    popupOverlay.classList.add('active');
    document.querySelector('html').classList.add('noscroll');
    slideToDisplayFirst();
  });
}

// CLOSE POP-UP
// with close button

if (closeButton != undefined) {
  closeButton.addEventListener('click', function () {
    closePopup();
  });
}

// with overlay
if (popupOverlay != undefined) {
  popupOverlay.addEventListener('click', function () {
    closePopup();
  });
}

/* ----------------------------------- */
// Initialize slider 

var flkty = new Flickity('.engraving-slider__slider', {
  groupCells: true,
  cellAlign: 'center',
  prevNextButtons: true,
  pageDots: false,
  wrapAround: true
});

/* ------------ FUNCTIONS ------------ */

function closePopup() {
  popupSlider.classList.remove('active');
  popupOverlay.classList.remove('active');
  document.querySelector('html').classList.remove('noscroll');
}
function slideToDisplayFirst() {
  // Get the selected typo on the select
  let valueSelect = document.querySelector('.engraving-form__typo select').value;
  if (valueSelect == "") {
    // If no typography is selected in the list, display the slider normally
    return;
  } else {
    // If a typography is selected, get the matching slide and its index and open the slider with this first slide
    let matchingSlide = document.querySelector(`.engraving-slider__slide[data-typography="${valueSelect}"]`);
    let indexSlide = matchingSlide.getAttribute('data-index');
    flkty.select(parseInt(indexSlide) - 1, false, true);
  }
}